import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAllFeatureConfigs } from '../config/featureDisplayConfig';

// Thanh đầu trang: logo → màn hình chính · 3 tính năng đầu · tên người dùng (Mã - Tên) · đăng xuất.
// Chép từ PE_Form/SystemHeader.js, bỏ điểm thưởng và mục "Cập nhật thông tin" (QD-06).
const SystemHeader = ({ userInfo, onLogout, pageTitle = 'Tuệ Hải Minh' }) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const path = window.location.pathname;
  const topFeatures = getAllFeatureConfigs().filter((f) => f.enabled !== false).slice(0, 3);
  const displayName = `${userInfo?.code || userInfo?.id || ''}-${userInfo?.facebook || userInfo?.name || ''}`;

  const NutTinhNang = ({ f, idx }) => {
    const active = path === f.path || path.startsWith(f.path + '/');
    return (
      <button onClick={() => { navigate(f.path); setOpen(false); }}
        className={`px-4 py-2 rounded-lg font-medium transition-all text-left ${active ? 'bg-brand-600 text-white shadow-md' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`}>
        <span className="text-xs opacity-60 mr-1">{f.order || idx + 1}.</span>{f.name}
      </button>
    );
  };

  return (
    <nav className="bg-white shadow-sm border-b">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-3">
          <button onClick={() => navigate('/dashboard')} title="Về màn hình chính"
            className="w-10 h-10 rounded-lg bg-brand-500 text-white font-black text-xs flex items-center justify-center shadow-sm active:scale-95">THM</button>

          <div className="hidden md:flex items-center space-x-2 flex-1 mx-4">
            {topFeatures.map((f, idx) => <NutTinhNang key={f.key} f={f} idx={idx} />)}
          </div>
          <div className="md:hidden flex-1 text-center text-sm font-semibold text-gray-800 truncate px-2">{pageTitle}</div>

          <div className="hidden md:flex items-center space-x-3">
            <div className="text-right">
              <p className="text-sm font-medium text-gray-900">{displayName}</p>
              <p className="text-xs text-gray-500">{userInfo?.userName || userInfo?.username || ''}</p>
            </div>
            <button onClick={onLogout} className="px-3 py-2 rounded-lg bg-gray-100 hover:bg-red-50 hover:text-red-600 text-sm font-medium text-gray-700">Đăng xuất</button>
          </div>
          <button onClick={() => setOpen((o) => !o)} className="md:hidden p-2 rounded-lg hover:bg-gray-100" aria-label="Menu">
            <span className="material-symbols-rounded">{open ? 'close' : 'menu'}</span>
          </button>
        </div>
        {open && (
          <div className="md:hidden pb-3 space-y-2">
            <p className="text-sm font-medium text-gray-900 px-1">{displayName}</p>
            <div className="flex flex-col gap-1.5">{topFeatures.map((f, idx) => <NutTinhNang key={f.key} f={f} idx={idx} />)}</div>
            <button onClick={onLogout} className="w-full py-2 rounded-lg bg-red-50 text-red-600 text-sm font-medium">Đăng xuất</button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default SystemHeader;
